import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { ResponsiveImage, Link } from "@quintype/components";
import SectionName from "../../atoms/section-name";
import Headline from "../../atoms/headline";

import "./styles.m.css";

function StoryHeaderBase({ story = {}, showHeroImage, iconLiveBlogClass, subTitleClass }) {
  const storyTemplateType = get(story, ["metadata", "story-attributes", "layout"], "");

  // Get the Hero image
  const getHeroImage = () => {
    return (
      <figure>
        <ResponsiveImage
          slug={story["hero-image-s3-key"]}
          metadata={story["hero-image-metadata"]}
          aspectRatio={[16, 9]}
          imgParams={{ auto: ["format", "compress"] }}
        />
        {story["hero-image-caption"] && (
          <figcaption className="story-element-image-title">{story["hero-image-caption"]}</figcaption>
        )}
      </figure>
    );
  };

  const sectionName = story.sections[0]["display-name"] || story.sections[0]["name"];
  const sectionSlug = story.sections[0]["slug"] || "";

  return (
    <div styleName="wrapper">
      <Link href={`/${sectionSlug}`}>
        <SectionName name={sectionName} />
      </Link>
      {storyTemplateType[0] === "image-first" ? getHeroImage() : null}
      <Headline text={story.headline} headerType={12} headerLevel={2} />
      {story.subheadline && <Headline text={story.subheadline} headerType={11} headerLevel={2} />}

      {storyTemplateType[0] !== "image-first" && showHeroImage && getHeroImage()}
    </div>
  );
}

StoryHeaderBase.propTypes = {
  story: PropTypes.object,
  showHeroImage: PropTypes.bool,
  iconLiveBlogClass: PropTypes.string,
  subTitleClass: PropTypes.string
};

export default StoryHeaderBase;
